import { PDFImage } from './pdf-image';

export class PDFGenerator {

	styles: string = '';
	content: string = '';

	generateProposalPDF ( client, proposal_id, newInstallation, projectInfo ) {

		// ToDo make something with styles
		this.styles = '<style>'+
		'body{color:#444;}'+
		'.--body{position:relative;}'+
    '@page {margin-top: 120px;margin-left: 25px;margin-right: 25px;}'+
    '@page :first {margin-top: 0;margin-left: 0;margin-right: 0;margin-bottom: 0;padding:0;}'+
		'header{z-index:2;position: fixed; top: -95px; left: 0px; right: 0px;padding: 0 10px;width:100%;border-bottom:2px solid #9a9a9a; height:85px;}'+
		'.container{width:100%!important;zoom:.6;}'+
		'body{font-size: 12px;font-family: sans-serif;}'+
		'hr{display:none;}'+
		'th,td{width:1px !important;}'+
		'.calculation-container{padding:15px;background:#fff;border:1px solid #ddd;overflow-x:auto;}'+
		'.calculation-container__title{font-size:2em;margin-bottom:15px;font-weight:bold;}'+
		'.calculation-block__title{font-size:1.3em;font-weight:bold;text-decoration:underline;}'+
		'table{font-size:1.1em;text-align:center;margin:15px 0;border-spacing:0;border:1px solid #555;}th.tal,td.tal{text-align:left;}'+
		'tfoot td{font-weight:bold;}'+
		'.after-table-info{font-size:1.3em;display:block;width:400px;max-width:100%;font-weight:bold;text-align:right;white-space:nowrap;}'+
		'.after-table-info span{display:inline-block;float:left;font-weight:normal;}'+
		'.after-table-info.metrics{width:60px;padding-left:5px;float:right;text-align:left;}'+
		'.table-sign{font-weight:bold;line-height:1.25em;}table.table{width:100%;max-width:100%;}'+
		'th{text-align:center;padding:3px 5px;}.table-sign__column{width:30px;}td>strong.big{font-size:1.2em;}'+
		'.graph-container{padding:20px;text-align:center;}'+
		'.graph-block {display:inline-block;height:250px;width:300px;border-top:2px solid #333;border-right:2px solid #333;transform: rotate(180deg);position:relative;text-align: center;}'+
		'.graph-label {text-align: center;margin: 5px 0;font-size: 1.5em;font-weight: bold;margin-bottom: 2.5em;}'+
		'.graph-value {position: relative;display: inline-block;vertical-align: top;white-space: nowrap;width: 75px;background: #8ac440;height: 100%;min-height: 1px;margin: auto 20px;}'+
		'.graph-value>div{position: relative;text-align: center;top: -3em;width: 100%;font-size: 1.2em;font-weight: bold;transform: rotate(180deg);}'+
		'.graph-value>div.graph-value-label {top: -2.4em;color:#fff;}'+
		'.view-specs__popup{margin-top: 21px;vertical-align: top;display: inline-block;border: 1px solid #8ac440;padding: 6px 12px;font-size: 1.2em;font-weight: bold;border-radius: 5px;width: 100%;text-align: center;cursor: pointer;}'+
		'.zone-body__light-image-wrapper{float:left;width:150px;margin-right:10px;}'+
		'table tbody tr:nth-child(odd){background:#f5f5f5;}'+
		'table tr{border-bottom:0;border:1px solid #555;}'+
		'table td{vertical-align:middle;border-top:1px solid #555;border-bottom:1px solid #555;padding:3px 5px;}'+
		'.table-img-wrapper{width:100px;max-height:100px;text-align:center;margin:0 auto;padding:0;}'+
		'.table-img-wrapper>img{max-width:3cm;max-height:3cm;}'+
		'.page_break{page-break-before:always;}'+
		'.pdf-subtitle{font-size:0.7em;text-align:center;margin-top:10px;margin-bottom:30px;}'+
		'.pdf-subtitle>span{font-weight:bold;font-size:1.4em;}'+
		'.pdf-subtitle>span.prepared-for{font-weight:bold;font-size:1.4em;}'+
		'.pdf-paragraph{margin-bottom:15px;}'+
		'.pdf-logo{width:30%;margin-bottom:20px;}'+
		'.pdf-logo>img{max-width:100%;}'+
		'.pdf-header-wrapper{width:80%;margin:20px auto;}'+
		'.pdf-title{font-size:1.5em;text-align:center;border:3px solid #000;background:#00b050;padding:6px 0;color: #111;}'+
		'.col-xs-12{width:100%;}'+
		'.col-md-6{float:left;width:50%;}'+
		'.big-image{width:90%;margin:20px auto;text-align:center;}'+
		'.big-image img{height:200px;}'+
		'.main-page-labels>div{font-size: 1.625em;line-height:1.5em;}'+
		'span.green-text{color:#8ac440;}'+
		'.pdf-invisible{display:none;}'+
		'.proposal-wide{width:200px;}'+
		'.table-column__width-sign{padding-top:24px;}'+
		'.proposal__job-details-wrapper {font-size: 1.25em;margin-top: 120px;}'+
		'.product-info__container{margin:10px 0;}'+
		'.product-info__image-wrapper{text-align:center;width:100%;}'+
		'.product-info__image{width:auto;height:auto;max-height:250px;max-width:100%;}'+
		'.product-info__title{text-align:center;border-bottom:1px solid #c2c2c2;padding:0 5px;margin:10px 0;font-size: 1.625em;color:#000;}'+
		'.product-info__basic-specs{font-size:1.125em;}'+
		'.mb15{margin-bottom:15px;width:100%;height:1px;}'+
		'.bid-code{text-align:right;color:#ce2546;font-size:1.3em;}'+
		'.option-name{text-align: center; font-size: 2.3em; text-decoration: underline;}'+
		'</style>';
		
		this.content = ''+
		'<div style="float:right;font-size:1.5em;position:relative;top:-45px;">Estimate #'+proposal_id+'</div>'+
		'<header>'+
		' <div class="pdf-logo">'+
		' 	<img src="'+PDFImage.logo+'" />'+
		' </div>'+
		// '	<div class="custom-separator"></div>'+
		'</header>'+
		' <div class="pdf-header-wrapper">';

		this.content += '		<h1 style="text-align:center;">Energy Efficiency LED Lighting Upgrade</h1>';
		this.content += '		<h1 style="text-align:center;">'+projectInfo.Name+'</h1>';
		this.content += '		<div class="big-image"><img src="'+PDFImage.proposal+'"></img></div>';
		this.content += '		<div style="padding-left:45px;" class="col-md-6 main-page-labels">';
		this.content += '			<div><strong>Designed for:</strong</div>';
		this.content += '			<div>&nbsp;</div>';
		this.content += '			<div>'+projectInfo.Contact+'</div>';
		this.content += '			<div>'+projectInfo.Street+'</div>';
		this.content += '			<div>'+projectInfo.City+', '+projectInfo.State+' '+projectInfo.ZipCode+'</div>';
		this.content += '		</div>';
		this.content += '		<div style="padding-left:85px;" class="col-md-6 main-page-labels">';
		this.content += '			<div><strong>Prepared by:</strong</div>';
		this.content += '			<div>&nbsp;</div>';
		this.content += '			<div>'+projectInfo.Sales+'</div>';
		this.content += '			<div>NY Lighting Group, Inc.</div>';
		this.content += '			<div>1249 Broadway</div>';
		this.content += '			<div>Hewlett, NY 11557</div>';
		this.content += '			<div>888-986-9533</div>';
		this.content += '		</div>';
		this.content += '	</div>';


		let _block1: string = '';
		let _block2: string = '';
		let _block3: string = '';

		let _today = new Date();
		let _date: string = '';

		_date = (_today.getMonth()+1)+'-'+(_today.getDate())+'-'+(_today.getFullYear());
		if (_today.getDate() < 10) {
			_date = (_today.getMonth()+1)+'-'+('0'+_today.getDate())+'-'+(_today.getFullYear());
		}

		_block1 += '	<div style="color:#002056;position:relative;z-index:1;margin-left:35px;margin-right:35px;margin-top:20px;text-align:right;font-weight:bold;">';
		_block1 += '<div style="font-size:26px;">Estimate# '+proposal_id+'</div>';
		_block1 += '<div style="font-size:22px;">Date: '+_date+'</div>';
		_block1 += '	</div>';

		_block2 += '	<div style="position:absolute;top:34%;width:100%;height:40px;z-index:10;margin-left:35px;margin-right:35px;white-space:nowrap;">';
		_block2 += '<div style="width:59%;display:inline-block;position:relative;vertical-align:middle;"><img style="max-width:100%;max-height:4cm;" src="'+PDFImage.logo+'"></img></div>';
		_block2 += '<div style="width:40%;display:inline-block;position:relative;vertical-align:middle;text-align:right;color:#002056;font-size:30px;font-weight:bold;white-space:normal;">PROJECT:<br />'+projectInfo.Name+'</div>';
		_block2 += '	</div>';


		_block3 += '	<div style="color:#fff;margin-top:2cm;margin-left:35px;margin-right:35px;">';
		_block3 += '		<div style="float: left;" class="main-page-labels">';
		_block3 += '			<div><strong>Quote for:</strong</div>';
		_block3 += '			<div>&nbsp;</div>';
		_block3 += '			<div>'+projectInfo.Contact+'</div>';
		_block3 += '			<div>'+projectInfo.Company+'</div>';
		_block3 += '			<div>'+projectInfo.Street+'</div>';
		_block3 += '			<div>'+projectInfo.City+', '+projectInfo.State+' '+projectInfo.ZipCode+'</div>';
		_block3 += '		</div>';
		_block3 += '		<div style="float: right;" class="main-page-labels">';
		_block3 += '			<div><strong>Prepared by:</strong</div>';
		_block3 += '			<div>&nbsp;</div>';
		_block3 += '			<div>'+projectInfo.Sales+'</div>';
		_block3 += '			<div>NY Lighting Group, Inc.</div>';
		_block3 += '			<div>1249 Broadway</div>';
		_block3 += '			<div>Hewlett, NY 11557</div>';
		_block3 += '			<div>888-986-9533</div>';
		_block3 += '		</div>';
		_block3 += '	</div>';


		this.content = '';

		this.content += '<div class="--body">';
		this.content += '  <div style="position: absolute;height:46%;background:#fff;top:0;width:100%;left:0;z-index:5;">';
		this.content += _block1;
		this.content += _block2;
		this.content += '  </div>';

		this.content += '  <div style="position: absolute;top: 46%;left: 0;width: 100%;height: 3%;background: #9EABBE;z-index:2;"></div>';
		this.content += '  <div style="position: absolute;top: 49%;left: 0;width: 100%;height: 3%;background: #3C557E;z-index:3;"></div>';

		this.content += '  <div style="position: absolute;top: 52%;left: 0;width: 100%;height: 48%;background: #002056;z-index:4;">';
		this.content += _block3;
		this.content += '  </div>';

		this.content += '</div>';

		this.content += '<header><div class="pdf-logo"><img src="'+PDFImage.logo+'" /></div></header>';
	}

	getProposalTerms ( start_break ) {
		let _termsHTML = '';
		if( start_break) {
			_termsHTML +='<div class="page_break"></div>';
		}
		_termsHTML +='<p><strong>TERMS:</strong></p>';
		_termsHTML +='<br />';
		_termsHTML +='<p><strong>BILLING:</strong> Payment due in Advance. Fifty percent (50%) down with order, Balance due before shipping for all orders. A finance charge of 1.5% per month will be accrued on all unpaid past due invoices, immediately after due date, plus all legal fees associated with collections of any outstanding debt.</p>';
		_termsHTML +='<br />';
		_termsHTML +='<p><strong>CANCELLATIONS:</strong> Cancelled orders are subject to a twenty percent (20%) cancellation fee.</p>';
		_termsHTML +='<br />';
		_termsHTML +='<p><strong>RETURNS:</strong> NY LIGHTING GROUP can only return Product shipped with written authorization via the Return Merchandise Authorization process, Customer is responsible for all shipping charges. Returns are subject to a twenty percent (20%) restocking charge. LED Lamps are not returnable after 30 days from Invoice.</p>';
		_termsHTML +='<br />';
		_termsHTML +='<p><strong>SHIPPING CHARGES:</strong> NY LIGHTING GROUP will ship freight prepaid and re-bill freight charges. If buyer selects carrier shipments will be freight collect. Additional fees may be charged for special or rush requests by buyer</p>';
		_termsHTML +='<br />';
		_termsHTML +='<p>Signature: _____________________________</p>';
		_termsHTML +='<br />';
		_termsHTML +='<p>Date: ________________</p>';
		return _termsHTML;
	}

	generateInvoicePDF ( data, projectInfo ) {

	  let _billing_html:string = '';
	  let _shipping_html:string = '';
		let _products_info:string = '';
		let _attachment:string = '';
		let _invoice_due_date:string = '';
		let tds:string = '';
		let i:number = 0;
		let invoice_id:number = 2999 + projectInfo.invoice_id;
		let _due_total:string = '--------';

		let _paymMethods = {
			Cash: 'Cash',
			Check: 'Check',
			CreditCard: 'Credit card'
		};

    if ( projectInfo.CustomerName ) _billing_html += '<p>'+projectInfo.CustomerName+'</p>';
    // if ( projectInfo.Company ) _billing_html += '<p>'+projectInfo.Company+'</p>';
    if ( projectInfo.BillingStreet ) _billing_html += '<p>'+projectInfo.BillingStreet+'</p>';
    _billing_html += '<p>';
    if ( projectInfo.BillingCity ) _billing_html += projectInfo.BillingCity+', ';
    if ( projectInfo.BillingState ) _billing_html += projectInfo.BillingState+' ';
    if ( projectInfo.BillingZipCode ) _billing_html += projectInfo.BillingZipCode;
    _billing_html += '</p>';

    // if ( projectInfo.SameAsBillingAddress == 1 ) {
    // 	_shipping_html = _billing_html;
    // } else {
	    if ( projectInfo.Company ) _shipping_html += '<p>'+projectInfo.Company+'</p>';
	    if ( projectInfo.Contact ) _shipping_html += '<p>'+projectInfo.Contact+'</p>';
	    if ( projectInfo.ShippingStreet ) _shipping_html += '<p>'+projectInfo.ShippingStreet+'</p>';
	    _shipping_html += '<p>';
	    if ( projectInfo.ShippingCity ) _shipping_html += projectInfo.ShippingCity+', ';
	    if ( projectInfo.ShippingState ) _shipping_html += projectInfo.ShippingState+' ';
	    if ( projectInfo.ShippingZipCode ) _shipping_html += projectInfo.ShippingZipCode;
	    _shipping_html += '</p>';
    // }

    _invoice_due_date = projectInfo.invoice_due_date;
    if (+data.due_total < 0 || data.due_total == '0.00' || projectInfo.status == 'projectCancelled' ) _invoice_due_date = '--------';

    if ( projectInfo.showProductCost ) {

		for ( i = 0; i < data.product_list.proposed.length; ++i ) {
			tds += '<tr>';
			let _manufacturerString = '';
			let _SKUString = '';
			if ( projectInfo.showManufacturer ) _manufacturerString = data.product_list.proposed[i].manufacturer_name+'<br />';
			if ( projectInfo.showSKU ) _SKUString = '<strong>'+data.product_list.proposed[i].SKU+'</strong><br />';
			tds += '<td class="big-column">'+_manufacturerString+_SKUString+data.product_list.proposed[i].description+'</td>';
			tds += ''+
			'<td>'+data.product_list.proposed[i].quantity+'</td>'+
			'<td>'+data.product_list.proposed[i].sellPrice+'</td>'+
			'<td>'+data.product_list.proposed[i].cost+'</td>'+
			'</tr>'+
			'';
		}
	} else {

		for ( i = 0; i < data.product_list.proposed.length; ++i ) {
			tds += '<tr>';
			let _manufacturerString = '';
			let _SKUString = '';
			if ( projectInfo.showManufacturer ) _manufacturerString = data.product_list.proposed[i].manufacturer_name+'<br />';
			if ( projectInfo.showSKU ) _SKUString = '<strong>'+data.product_list.proposed[i].SKU+'</strong><br />';
			tds += '<td class="big-column">'+_manufacturerString+_SKUString+data.product_list.proposed[i].description+'</td>';
			tds += ''+
			'<td>'+data.product_list.proposed[i].quantity+'</td>'+
			'<td>x</td>'+
			'<td>x</td>'+
			'</tr>'+
			'';
		}
	}

		for ( i = 0; i < data.product_list.proposed.length; ++i ) {
			let _bitCode = ( data.product_list.proposed[i].bitCode && data.product_list.proposed[i].bitCode != null && data.product_list.proposed[i].bitCode != 'null' ) ? data.product_list.proposed[i].bitCode : '';
			_attachment = '';
			if ( data.product_list.proposed[i].attachment ) _attachment = '<img class="product-info__image" src="'+data.product_list.proposed[i].attachment+'">';
			if( i != 0 || !projectInfo.viaQuickbooks ) {
				_products_info += '<div class="page_break"></div>';
			}
			_products_info += '<div class="mb15"></div>';
			_products_info += '	<div class="product-info__container">';
			_products_info += '		<div class="product-info">';
			_products_info += '   <div class="bid-code">'+_bitCode+'</div>'
			if ( _attachment ) _products_info += '<div class="product-info__image-wrapper">'+_attachment+'</div>';
			_products_info += '			<div>';
			_products_info += '				<div class="product-info__title">'+data.product_list.proposed[i].description+'</div>';
			_products_info += '			<div class="product-info__basic-specs">'+data.product_list.proposed[i].basicSpec+'</div>';
			if ( data.product_list.proposed[i].specsPDF ) _products_info += '			<div class="product-info__basic-specs"><a href="'+data.product_list.proposed[i].specsPDF+'">Click here to see Specifications</a></div>';
			_products_info += '			</div>';
			_products_info += '		</div>';
			_products_info += '	</div>';
			_products_info += '</div>';
		}

		if ( data.consultation_fee && data.consultation_fee != '0.00' ) {
			tds += ''+
			'<tr>'+
			'<td class="big-column"><strong>Consultation fee</strong></td>'+
			'<td>1</td>'+
			'<td>'+data.consultation_fee+'</td>'+
			'<td>'+data.consultation_fee+'</td>'+
			'</tr>'+
			'';
		}


		if ( data.InstallationCost && data.InstallationCost != '0.00' ) {
			tds += ''+
			'<tr>'+
			'<td class="big-column"><strong>Labor</strong></td>'+
			'<td>1</td>'+
			'<td>'+data.InstallationCost+'</td>'+
			'<td>'+data.InstallationCost+'</td>'+
			'</tr>'+
			'';
		}

		if ( projectInfo.importDuties && projectInfo.importDuties != '0.00' ) {
			tds += ''+
			'<tr>'+
			'<td class="big-column"><strong>Import duties</strong></td>'+
			'<td>1</td>'+
			'<td>'+projectInfo.importDuties+'</td>'+
			'<td>'+projectInfo.importDuties+'</td>'+
			'</tr>'+
			'';
		}


		if ( projectInfo.insuranceCost && projectInfo.insuranceCost != '0.00' ) {
			tds += ''+
			'<tr>'+
			'<td class="big-column"><strong>Cargo insurance cost</strong></td>'+
			'<td>1</td>'+
			'<td>'+projectInfo.insuranceCost+'</td>'+
			'<td>'+projectInfo.insuranceCost+'</td>'+
			'</tr>'+
			'';
		}


		tds += ''+
			'<tr>'+
			'<td class="big-column"><strong>Shipping</strong></td>';
		if( data.shippingCost ) {

			if ( data.shippingCost != '0.00' ) {
				tds += '<td>1</td>'+
					'<td>'+data.shippingCost+'</td>'+
					'<td>'+data.shippingCost+'</td>';
			} else {
				tds += '<td></td>'+
					'<td></td>'+
					'<td>FREE</td>';
			}
		}
		else {
			tds += '<td></td>'+
				'<td></td>'+
				'<td>TBD</td>';
		}
		tds += '</tr>'+
			'';


		if ( projectInfo.jobDetails && projectInfo.jobDetails != '' ) {
			tds += ''+
			'<tr>'+
			'<td class="big-column"><strong>Job details</strong></td>'+
			'<td></td>'+
			'<td></td>'+
			'<td></td>'+
			'</tr>'+
			'';
			tds += ''+
			'<tr>'+
			'<td class="big-column">'+projectInfo.jobDetails+'</td>'+
			'<td></td>'+
			'<td></td>'+
			'<td></td>'+
			'</tr>'+
			'';
		}

		if ( projectInfo.shippingDetails && projectInfo.shippingDetails != '' ) {
			tds += ''+
			'<tr>'+
			'<td class="big-column"><strong>Shipping details</strong></td>'+
			'<td></td>'+
			'<td></td>'+
			'<td></td>'+
			'</tr>'+
			'';
			tds += ''+
			'<tr>'+
			'<td class="big-column">'+projectInfo.shippingDetails+'</td>'+
			'<td></td>'+
			'<td></td>'+
			'<td></td>'+
			'</tr>'+
			'';
		}

		if ( data.discount_amount != 0 ) {
			tds += ''+
			'<tr>'+
			'<td class="big-column"><strong>Discount</strong><br />'+data.discount+'% Off- Courtesy Discount</td>'+
			'<td>1</td>'+
			'<td>-'+data.discount_amount+'</td>'+
			'<td>-'+data.discount_amount+'</td>'+
			'</tr>'+
			'';
		}


		tds += ''+
		'<tr>'+
		'<td class="big-column"><strong>Deposit/Credit</strong></td>'+
		'<td>1</td>'+
		'<td>-'+projectInfo.depositAmountNumber+'</td>'+
		'<td>-'+projectInfo.depositAmountNumber+'</td>'+
		'</tr>'+
		'';

		if ( data.rebates != '0.00' ) {
			tds += '' +
				'<tr>' +
				'<td class="big-column"><strong>Rebates/Incentives</strong></td>' +
				'<td>1</td>' +
				'<td>-' + data.rebates + '</td>' +
				'<td>-' + data.rebates + '</td>' +
				'</tr>' +
				'';
		}

		tds += ''+
		'<tr>'+
		'<td class="big-column"><strong>Payment method</strong></td>'+
		'<td></td>'+
		'<td></td>'+
		'<td class="nowrap">'+_paymMethods[projectInfo.paymentMethod]+'</td>'+
		'</tr>'+
		'';

		this.styles = '<style>'+
		'.container{width:100%!important;zoom:.6;}'+
		'body{font-size:16px;font-family:sans-serif;}'+
		'hr{display:none;}'+
		'th{text-align:center;}'+
		'table td{vertical-align:middle;width:75px;}'+
		'.page_break{page-break-before:always;}'+
		'.pdf-subtitle{font-size:0.7em;text-align:center;margin-top:10px;margin-bottom:30px;}'+
		'.pdf-subtitle>span{font-weight:bold;font-size:1.4em;}'+
		'.pdf-paragraph{margin-bottom:15px;}'+
		'.pdf-logo{vertical-align:top;width:29%;display:inline-block;text-align:right;}'+
		'.pdf-logo>img{vertical-align:top;max-width:70%;}'+
		'p{margin:0;}'+
		'.w70{display:inline-block;width:70%;text-align:left;}'+
		'.w55{display:inline-block;width:55%;text-align:left;}'+
		'.w54{display:inline-block;width:45%;text-align:left;position: relative;}'+
		'.w29{display:inline-block;width:29%;text-align:left;}'+
		'.padding20{padding:0 20px;}'+
		'.fl{float:left;}'+
		'.blue-border-bottom{border-bottom:3px solid #202e5a;padding-bottom:1px;}'+
		'.header-blue{line-height:24px;vertical-aling:bottom;height:24px;position:relative;display:block;width:100%;box-sizing:border-box;background:#202e5a;color:#fff;padding:7px 3px;text-align:left;margin-top:3px;}'+
		'.header-blue strong{display:inline-block;}'+
		'.header-blue span{display:inline-block;}'+
		'.header-container{text-align:justify;margin-bottom:15px;clear:both;}'+
		'.clearfix{clear:both;}'+
		'.header-container strong{font-size:1.2em;}'+
		'.body-container{width:100%;}'+
		'table{display:table;width:100%;border-collapse:collapse;}'+
		'thead td{background:#202e5a;color:#fff;}'+
		'td{text-align:right;border:none;border-bottom:1px solid #bbcecf;padding:3px;width:250px;}'+
		'.big-column{width:500px;text-align:left;}'+
		'.product-info__container{margin:10px 0;}'+
		'.product-info__image-wrapper{text-align:center;width:100%;}'+
		'.product-info__image{width:auto;height:auto;max-height:250px;max-width:100%;}'+
		'.product-info__title{text-align:center;border-bottom:1px solid #c2c2c2;padding:0 5px;margin:10px 0;font-size: 1.5em;}'+
		'.product-info__basic-specs{font-size:0.85em;}'+
		'.mb15{margin-bottom:15px;width:100%;height:1px;}'+
		'.nowrap{white-space:nowrap;}'+
		'.bid-code{text-align:right;color:#ce2546;font-size:1.3em;}'+
		'.total-line{padding-left:20px;width:100%;position:relative;height:25px;}'+
		'.total{left:20px;position:absolute;}'+
		'.total-value{right:100px;position:absolute;}'+
		'</style>';

		if( !projectInfo.viaQuickbooks ) {

			this.content = ''+
				'<div class="header-container">'+
				'	<div class="w70">'+
				'		<div class="padding20">'+
				'			<strong>NY Lighting Group Inc</strong>'+
				'			<p>1249 Broadway</p>'+
				'			<p>Hewlett, NY 11557 US</p>'+
				'			<p>Customerservice@ny-lg.com</p>'+
				'			<p>www.ny-lg.com</p>'+
				'		</div>'+
				'	</div>'+
				'	<div class="pdf-logo">'+
				'		<img src="'+PDFImage.logo+'" />'+
				'	</div>'+
				'</div>'+
				'<div class="header-container" style="margin-top:20px;">'+
				'	<div class="w70 blue-border-bottom">'+
				'		<div class="padding20">'+
				'			<div class="fl">'+
				'				<strong>BILL TO</strong>'+_billing_html+
				'			</div>'+
				'			<div class="fl" style="margin-left:40px;">'+
				'				<strong>SHIP TO</strong>'+_shipping_html+
				'			</div>'+
				'			<div class="clearfix"></div>'+
				'		</div>'+
				'	</div>'+
				'	<div class="w29 blue-border-bottom">'+
				'		<div class="header-blue"><strong>INVOICE #'+invoice_id+'</strong></div><br />'+
				'		<div class="header-blue"><strong>DATE</strong> <span>'+projectInfo.invoice_updated+'</span></div><br />'+
				'		<div class="header-blue"><strong>DUE DATE</strong> <span>'+_invoice_due_date+'</span></div>'+
				'	</div>'+
				'</div>'+
				'<div class="body-container">'+
				'	<table>'+
				'		<thead>'+
				'			<tr><td class="big-column">PRODUCT DESCRIPTION</td><td>QTY</td><td>RATE</td><td>AMOUNT</td></tr>'+
				'		</thead>'+
				'		<tbody>'+
				'			'+tds+
				'		</tbody>'+
				'	</table>'+
				'</div>';

			if ( projectInfo.notes.length ) {
				// <span style="display:inline-block;vertical-align:bottom;">'+note.username+'</span>
				this.content += '<div class="clearfix page_break" style="margin-top:30px;"></div>';
				this.content += '<h3>Notes</h3>';
				projectInfo.notes.reverse( ).forEach( ( note ) => {
					this.content += ''+
						'<div style="margin-top:4px;">'+
						'  <div style="color:#3131b9;font-weight:bold;"><span style="display:inline-block;vertical-align:bottom;">'+note.date+'</span></div>'+
						'  <div style="margin:5px 0;border-bottom:1px solid #e8e8e8;">'+note.Text+'</div>'+
						'</div>';
				});
			}

			this.content += ''+
				'<div class="clearfix page_break" style="margin-top:30px;"></div>'+
				'<div>'+
				'	<div class="w55">'+
				' BILLING: Payment due in Advance. Fifty percent'+
				' (50%) down with order, Balance due before shipping for'+
				' all orders. A finance charge of 1.5% per month will'+
				' be accrued on all unpaid past due invoices,'+
				' immediately after due date, plus all legal fees'+
				' associated with collections of any outstanding debt.'+
				' CANCELLATIONS: Cancelled orders are subject to'+
				' a twenty percent (20%) cancellation fee.'+
				' RETURNS: NY LIGHTING GROUP can only return'+
				' Product shipped with written authorization via the'+
				' Return Merchandise Authorization process,'+
				' Customer is responsible for all shipping charges.'+
				' Returns are subject to a twenty percent (20%)'+
				' restocking charge. LED Lamps are not returnable'+
				' after 30 days from Invoice. SHIPPING CHARGES:'+
				' NY LIGHTING GROUP will ship freight prepaid and'+
				' re-bill freight charges. If buyer selects carrier'+
				' shipments will be freight collect. Additional fees may'+
				' be charged for special or rush requests by buyer.'+
				' Signature_________________ Date____________'+
				'	</div>'+
				'	<div class="w54">'+
				'		<div class="total-line"><span class="total">SUBTOTAL</span>'+
				'			<span class="total-value">' + data.productCost + '</span>' +
				'		</div>' +
				'		<div class="total-line"><span class="total">TAX ('+ data.tax + '%)</span>' +
				'			<span class="total-value">' + data.tax_amount + '</span>' +
				'		</div>' +
				'		<div class="total-line"><span class="total">TOTAL</span>'+
				'			<span class="total-value">' + data.total_after_rebates + '</span>' +
				'		</div>' +
				'	</div>' +
				'</div>'+
				'<div>'+
				'	<div class="w55">'+
				'	</div>'+
				'	<div class="w54">'+
				'		<div class="header-blue"><span>TOTAL DUE</span> <strong style="float:right;font-size:1.2em;">$'+data.total_due_after_rebates+'</strong></div>'+
				'	</div>'+
				'	'+_products_info+
				'</div>'+
				'';
		}
		else {
			this.content = _products_info;
		}
	}

	generateManufacturerPurchasePDF ( data ) {

		let tds:string = '';
		let _temp_date: any;
		let _date;
		let _date_formatted:any;
		let i:number = 0;

		// _temp_date  = new Date( data.orderDate );
    _temp_date = data.orderDate.toString( ).split( '-' );
    _date = new Date( _temp_date[0], +_temp_date[1]-1, _temp_date[2] );

		_date_formatted = ( _date.getMonth( ) + 1 ) + '/' + _date.getDate( ) + '/' + _date.getFullYear( );

		for ( i = 0; i < data.products.length; ++i ) {
			if (data.products[i].selected) {

				tds += '<tr>';
				tds += '<td class="big-column">'+data.products[i].manufacturer_name+'<br />'+'<strong>'+data.products[i].SKU+'</strong><br />'+data.products[i].description+'</td>';
				tds += ''+
				'<td>'+data.products[i].light_quantity+'</td>'+
				'<td>'+data.products[i].rate_new+'</td>'+
				'<td>'+data.products[i].total_amount+'</td>'+
				'</tr>'+
				'';
			}
		}


		this.styles = '<style>'+
		'.container{width:100%!important;zoom:.6;}'+
		'body{font-size:16px;font-family:sans-serif;}'+
		'hr{display:none;}'+
		'th{text-align:center;}'+
		'table td{vertical-align:middle;width:75px;}'+
		'.page_break{page-break-before:always;}'+
		'.pdf-subtitle{font-size:0.7em;text-align:center;margin-top:10px;margin-bottom:30px;}'+
		'.pdf-subtitle>span{font-weight:bold;font-size:1.4em;}'+
		'.pdf-paragraph{margin-bottom:15px;}'+
		'.pdf-logo{vertical-align:top;width:29%;display:inline-block;text-align:right;}'+
		'.pdf-logo>img{vertical-align:top;max-width:70%;}'+
		'p{margin:0;}'+
		'.w70{display:inline-block;width:70%;text-align:left;}'+
		'.w55{display:inline-block;width:55%;text-align:left;}'+
		'.w54{display:inline-block;width:45%;text-align:left;}'+
		'.w29{display:inline-block;width:29%;text-align:left;}'+
		'.padding20{padding:0 20px;}'+
		'.fl{float:left;}'+
		'.blue-border-bottom{border-bottom:3px solid #202e5a;padding-bottom:1px;}'+
		'.header-blue{line-height:24px;vertical-aling:bottom;height:24px;position:relative;display:block;width:100%;box-sizing:border-box;background:#202e5a;color:#fff;padding:7px 3px;text-align:left;margin-top:3px;}'+
		'.header-blue strong{display:inline-block;}'+
		'.header-blue span{display:inline-block;}'+
		'.header-container{text-align:justify;margin-bottom:15px;clear:both;}'+
		'.clearfix{clear:both;}'+
		'.header-container strong{font-size:1.2em;}'+
		'table{display:table;width:100%;border-collapse:collapse;}'+
		'thead td{background:#202e5a;color:#fff;}'+
		'td{text-align:right;border:none;border-bottom:1px solid #bbcecf;padding:3px;width:250px;}'+
		'.big-column{width:500px;text-align:left;}'+
		'.body-container{width:100%;}'+
		'</style>';
		
		this.content = ''+
		'<div class="header-container">'+
		'	<div class="w70">'+
		'		<div class="padding20">'+
		'			<strong>NY Lighting Group Inc</strong>'+
		'			<p>1249 Broadway</p>'+
		'			<p>Hewlett, NY 11557 US</p>'+
		'			<p>Customerservice@ny-lg.com</p>'+
		'			<p>www.ny-lg.com</p>'+
		'		</div>'+
		'	</div>'+
		'	<div class="pdf-logo">'+
		'		<img src="'+PDFImage.logo+'" />'+
		'	</div>'+
		'</div>'+
		'<div class="header-container" style="margin-top:20px;">'+
		'	<div class="w70 blue-border-bottom">'+
		'		<div class="padding20">'+
		'			<div class="fl">'+
		'				<strong>Manufacturer Address</strong><br />'+data.address+
		'			</div>'+
		'			<div class="fl" style="margin-left:40px;">'+
		'				<strong>Shipping Address</strong><br />'+data.shippingAddress+
		'			</div>'+
		'			<div class="clearfix"></div>'+
		'		</div>'+
		'	</div>'+
		'	<div class="w29 blue-border-bottom">'+
		'		<div class="header-blue"><strong>PURCHASE ORDER #'+data.orderNumber+'</strong></div><br />'+
		'		<div class="header-blue"><strong>DATE</strong> <span>'+_date_formatted+'</span></div><br />'+
		'	</div>'+
		'</div>'+
		'<div class="body-container">'+
		'	<table>'+
		'		<thead>'+
		'			<tr><td class="big-column">PRODUCT DESCRIPTION</td><td>QTY</td><td>RATE</td><td>AMOUNT</td></tr>'+
		'		</thead>'+
		'		<tbody>'+
		'			'+tds+
		'		</tbody>'+
		'	</table>'+
		'</div>'+
		'<div class="clearfix page_break" style="margin-top:30px;"></div>'+
		'<div>'+
		'<div>'+
		'	<strong>Special Instructions:</strong> '+data.specialInstructions+
		'</div>'+
		'<br />'+
		'<br />'+
		'<br />'+
		'	<div class="w55">'+
		'	</div>'+
		'	<div class="w54">'+
		'		<div class="header-blue"><span>TOTAL</span> <strong style="float:right;font-size:1.2em;">$'+data.totalAmount+'</strong></div>'+
		'	</div>'+
		'</div>'+
		'<div>'+
		'	<div class="w55">'+
		' <br /><br /><br /><br /><br />'+
		' Approved By ____________<br /><br /><br />'+
		' Date ____________'+
		'	</div>'+
		'	<div class="w54">'+
		'	</div>'+
		'</div>'+
		'';
	}

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/services/html_pdf/pdf-html.ts